/* eslint-disable react-hooks/exhaustive-deps */
import { Card } from 'antd'
import { steps } from './steps'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { CustomTitle } from 'src/components'
import { useTranslation } from 'next-i18next'
import styles from './RegisterCard.module.scss'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { selectedRegisterStep, trackEvent, cookiesSelector } from 'src/features'

const stepsEvents = {
  '1': 'EMAIL_PASSWORD_STEP',
  '2': 'USER_TYPE_STEP',
  '3': 'PROFILE_STEP',
  '4': 'USAGE_STEP',
}
const RegisterCard: React.FC = () => {
  const router = useRouter()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const currentStep = useAppSelector(selectedRegisterStep)
  const { loading } = useAppSelector(cookiesSelector)
  
  useEffect(() => {
    if(!loading){
      dispatch(trackEvent(router.route, 'STEP_VIEW', stepsEvents[1]))
    }

  }, [loading])

  useEffect(() => {
    if(!loading && currentStep>1){
      dispatch(trackEvent(router.route, 'STEP_VIEW', stepsEvents[currentStep]))
    }
  }, [currentStep, loading])

  const formSteps = [steps.CredentialsForm, steps.UserTypeForm, steps.PersonalDetailsFormRegister, steps.RolsForm]
  const CurrentStep = formSteps[currentStep - 1] || steps.CredentialsForm

  const cardProps = {
    className: styles.card,
    title: <CustomTitle label={t('Auth.Register.SignUp')} />,
    extra: <CustomTitle label={`${currentStep}/4`} className='float-right' type={null} />,
  }

  return <Card {...cardProps}><CurrentStep /></Card>
}

export default RegisterCard
